export const USER_ROLES = [
  'super_admin',
  'editor',
  'merchant',
  'traveller',
] as const

export type UserRole = (typeof USER_ROLES)[number]

export const ADMIN_ROLES: UserRole[] = ['super_admin', 'editor']

export const DEFAULT_ROLE: UserRole = 'traveller'

export function isUserRole(value: unknown): value is UserRole {
  return (
    typeof value === 'string' &&
    (USER_ROLES as readonly string[]).includes(value)
  )
}

export function hasRole(
  role: string | null | undefined,
  allowed: readonly UserRole[],
): boolean {
  if (!role || !isUserRole(role)) return false
  return allowed.includes(role)
}

export function isAdminRole(role: string | null | undefined): boolean {
  return hasRole(role, ADMIN_ROLES)
}

/** Post-login destination by role. */
export function homePathForRole(role: string | null | undefined): string {
  if (isAdminRole(role)) return '/admin'
  if (role === 'merchant') return '/merchant'
  return '/account'
}
